import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-background-50 mb-4">
              <i className="ri-book-open-line mr-2"></i>
              36漫画网
            </h3>
            <p className="text-sm leading-relaxed text-background-50/60">
              国内领先的在线漫画阅读平台，提供海量正版漫画免费在线阅读。每日更新，高清画质，为漫画爱好者打造极致阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/hot" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">热门推荐</Link></li>
              <li><Link to="/category/new" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">最新上架</Link></li>
              <li><Link to="/category/completed" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">已完结</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/romance" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱甜宠</Link></li>
              <li><Link to="/category/adventure" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">热血冒险</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">全部作品</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line"></i> contact@36manhua.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line"></i> 400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-wechat-line"></i> 36manhua_official
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors text-background-50/60 hover:text-background-50 whitespace-nowrap" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors text-background-50/60 hover:text-background-50 whitespace-nowrap" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors text-background-50/60 hover:text-background-50 whitespace-nowrap" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} 36漫画网 版权所有 | 京ICP备2020000001号
          </p>
          <p className="text-xs text-background-50/40">
            本站所有漫画均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}